'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.millisecondsAgo;


// WEBPACK FOOTER //
// ./~/sugar-date/number/millisecondsAgo.js